<template>
  <div>
    <h2>Lista de requisitos</h2>
    <app-upload-file
      v-for="(v, i) in listaRequisitos"
      :key="i"
      :requisite="v"
      @changed="(e) => onChanged(e, i)"
    />
  </div>
</template>
<script>
import AppUploadFile from './upload-file'
export default {
  name: 'AppRequisitos',
  components: { AppUploadFile },
  props: {
    listaRequisitos: {
      required: false,
      type: Array,
      default: []
    },
    data: {
      required: true,
      type: Array
    }
  },
  watch: {
    listaRequisitos (val) {
      console.log(val)
    }
  },
  created () {
  },
  methods: {
    onChanged (e, index) {
      const r = { ...this.listaRequisitos[index], e }
      this.$set(this.listaRequisitos, index, r)
    },
    validForm () {
      return !(this.listaRequisitos || []).find(x => !x.filePath)
    }
  }
}
</script>
